import {
  RewardItemDTO,
  RewardPeriodDTO,
  RewardPeriodRequestDTO,
  RewardRequest,
  RewardRequestDTO,
  RewardItemRequest,
  BulkRewardRequestStatusUpdate
} from '@/models';
import { axiosBase } from './axios-base';

export const fetchRewardPeriods = (): Promise<{ data: RewardPeriodDTO[] }> => {
  return axiosBase.get('/api/reward/periods');
};

export const createNewRewardPeriod = (body: RewardPeriodRequestDTO): Promise<{ data: RewardPeriodDTO }> => {
  return axiosBase.put('/api/reward/period', body);
};

export const fetchRewardPeriodById = (id: number): Promise<{ data: RewardPeriodDTO }> => {
  return axiosBase.get(`/api/reward/period/${id}`);
};

export const publishRewardPeriod = (id: number): Promise<{ data: RewardPeriodDTO }> => {
  return axiosBase.put(`/api/reward/period/${id}/publish`);
};

export const closeRewardPeriod = (id: number): Promise<{ data: RewardPeriodDTO }> => {
  return axiosBase.put(`/api/reward/period/${id}/close`);
};

export const fetchRewardItemByPeriodId = (id: number): Promise<{ data: RewardItemDTO[] }> => {
  return axiosBase.get(`/api/reward/period/${id}/items`);
};

export const createRewardItems = (
  body: RewardItemRequest[],
  rewardPeriodId: number
): Promise<{ data: RewardItemDTO[] }> => {
  return axiosBase.post(`/api/reward/period/${rewardPeriodId}/items`, body);
};

export const updateRewardItem = (body: RewardItemDTO): Promise<{ data: RewardItemDTO }> => {
  return axiosBase.put(`/api/reward/item`, body);
};

export const deleteRewardItem = (id: number): Promise<{ status: number }> => {
  return axiosBase.delete(`/api/reward/item/${id}`);
};

export const fetchRewardRequestByPeriodId = (id: number): Promise<{ data: RewardRequestDTO[] }> => {
  return axiosBase.get(`/api/reward/period/${id}/requests`);
};

export const fetchRewardRequestByUserId = (): Promise<{ data: RewardRequestDTO[] }> => {
  return axiosBase.get(`/api/reward/user/requests`);
};

export const fetchUserRedeemableDrops = (): Promise<{ data: number }> => {
  return axiosBase.get(`/api/reward/user/redeemableDrops`);
};

const buildRewardRequestFormData = (requestData: RewardRequest): FormData => {
  const formData = new FormData();
  formData.append('id', requestData.id?.toString() || '');
  formData.append('userId', requestData.userId.toString());
  formData.append('status', requestData.status);
  formData.append('reason', requestData.reason || '');
  formData.append('rewardItemId', requestData.rewardItemId?.toString() || '');
  formData.append('actualPrice', requestData.actualPrice?.toString() || '');
  if (requestData.invoiceImage) {
    formData.append('invoiceImage', requestData.invoiceImage);
  }
  return formData;
};

export const updateRewardRequest = (requestData: RewardRequest[]): Promise<{ data: RewardRequestDTO[] }> => {
  return axiosBase.put(`/api/reward/requests`, requestData);
};

export const bulkUpdateRewardRequestStatus = (
  body: BulkRewardRequestStatusUpdate
): Promise<{ data: RewardRequestDTO[] }> => {
  return axiosBase.put(`/api/reward/requests/bulk-status`, body);
};

export const userApproveRewardRequest = (requestData: RewardRequest): Promise<{ data: RewardRequestDTO }> => {
  return axiosBase.put(`/api/reward/request/userApprove`, buildRewardRequestFormData(requestData));
};

export const createRewardRequest = (body: RewardRequest): Promise<{ data: RewardRequestDTO }> => {
  return axiosBase.post(`/api/reward/request`, body);
};

export const updateRewardPeriod = (body: RewardPeriodRequestDTO): Promise<{ data: RewardPeriodDTO }> => {
  return axiosBase.put(`/api/reward/period`, body);
};

export const fetchAllRewardRequests = (): Promise<{ data: RewardRequestDTO[] }> => {
  return axiosBase.get('/api/reward/requests/all');
};
